"use strict";

angular
  .module("pe4h", [
    "ui.router",
    "ui.bootstrap", //from here on not template "includes"
    "LocalStorageModule",
    "ngFileUpload",
    "stripe.checkout",
    "angular-loading-bar",
    "cfp.loadingBar",
    "profile.routes",
    "about.routes",
    "resources.routes",
    "legal.routes",
    "ngMessages",
    //'ngAnimate',
    "truncate",
    "ngMap",
    "lazy-scroll",
    "angularGrid",
    "updateMeta",
  ])
  .config(function (
    $stateProvider,
    $urlRouterProvider,
    $httpProvider,
    $compileProvider,
    StripeCheckoutProvider,
    cfpLoadingBarProvider,
    $locationProvider
  ) {
    $compileProvider.debugInfoEnabled(false); //get this from some custom application configuration provider injected

    $urlRouterProvider.otherwise("/");

    // Setting to improve Google Indexes
    // Fabricio: Uncomment these lines before a deploy
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix("!");

    // create/modify/delete states according to project needs
    $stateProvider
      .state("index", {
        url: "/",
        controller: "Main",
        templateUrl: "components/main/main.html"
      })
      .state("first-step", {
        url: "/first-step",
        controller: "Login",
        templateUrl: "components/login/first-step.html"
      })
      .state("signup", {
        url: "/signup",
        controller: "Login",
        templateUrl: "components/login/signup.html"
      })
      .state("login", {
        url: "/login?next&params",
        controller: "Login",
        templateUrl: "components/login/login.html",
      })
      .state("forgotPassword", {
        url: "/reset-password",
        controller: "ForgotPassword",
        templateUrl: "components/login/forgot.html",
      })
      .state("recoverPassword", {
        url: "/recoverPassword?token",
        controller: "RecoverPassword",
        templateUrl: "components/password/recover.html"
      })
      .state("post-project", {
        url: "/request-proposals/:zip/:type",
        controller: "PostProject",
        templateUrl: "components/projects/post/post-project.html"
      })
      .state("requests", {
        url: "/requests/:first",
        controller: "Requests",
        templateUrl: "components/requests/requests.html",
        params: {
          requiresLogin: true
        }
      })
      .state("proposals", {
        url: "/my-projects/:uid",
        controller: "Proposal",
        templateUrl: "components/proposals/proposals.html",
        params: {
          requiresLogin: true
        }
      })
      .state("projects", {
        url: "/projects/:first?uid&token",
        controller: "Projects",
        templateUrl: "components/projects/projects.html",
        params: {
          requiresLogin: true
        }
      })
      .state("project", {
        url: "/:projectTitle/rfp/:uid?questions",
        controller: "Project",
        templateUrl: "components/projects/project.html"
      })
      .state("proposal", {
        url: "/project/:uid/proposal/:proposalId",
        controller: "Proposal",
        templateUrl: "components/proposals/proposal.html",
        params: {
          requiresLogin: true
        }
      })
      .state("view-projects", {
        url: "/contract-engineering-jobs",
        controller: "ViewProjects",
        templateUrl: "components/projects/viewProjects.html"
      })
      .state("view-projectsPinterest", {
        url: "/viewProjectsPinterest",
        controller: "ViewProjects",
        templateUrl: "components/projects/viewProjects2.html"
      })
      .state("view-engineers", {
        // url: "/engineers/{param1:[a-z-]*}{slash:[/]?}{param2:[a-z-]*}",
        url: "/engineers/:param1/:param2",
        controller: "ViewEngineers",
        templateUrl: "components/engineers/viewEngineers.html"
      })
      .state("view-engineer", {
        url: "/:engineer_description/resume/:uid",
        controller: "Profile",
        templateUrl: "components/profiles/profile.html"
      })
      .state("robots", {
        url: "/robots.txt",
        templateUrl: "robots.txt"
      })
      .state("sitemap", {
        url: "/sitemap.xml",
        templateUrl: "sitemap.xml"
      });

    // Auth and load interceptors

    $httpProvider.interceptors.push("AuthInterceptor");

    $httpProvider.interceptors.push("LoadInterceptor");

    StripeCheckoutProvider.defaults({
      name: "P.E. For Hire",
      key: window.configuration.stripePublicKey,
      image: "assets/img/PE4H_Logo_Hexagon.png"
    });

    // Loader styles
    // Dont show the loading if prerender
    cfpLoadingBarProvider.spinnerTemplate =
      '<div id="loading-bar-spinner"><div class="spin fa-spin"></div></div>';
    if(window.prerenderCloudIsServerSideRendering){
      cfpLoadingBarProvider.spinnerTemplate =
      '<div id="loading-bar-spinner" style="display:none"><div class="spin fa-spin"></div></div>';
    }
    cfpLoadingBarProvider.latencyThreshold = 100;

    function maillink(lhs, rhs) {
      document.write('<a href="mailto');
      document.write(":" + lhs + "@");
      document.write(rhs + '" >' + lhs + "@" + rhs + "</a>");
    }
  })
  .run(function ($window) {
    //inject something and do something when application starts
    gtag('config', 'UA-72874513-1');
  });
